var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 68,
    viewBox: "0 0 51 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_2599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 17C17 14.7457 16.1045 12.5837 14.5104 10.9896C12.9163 9.39553 10.7543 8.5 8.5 8.5C6.24566 8.5 4.08365 9.39553 2.48959 10.9896C0.895533 12.5837 0 14.7457 0 17C0 19.2543 0.895533 21.4163 2.48959 23.0104C4.08365 24.6045 6.24566 25.5 8.5 25.5C10.7543 25.5 12.9163 24.6045 14.5104 23.0104C16.1045 21.4163 17 19.2543 17 17ZM51 51C51 48.7457 50.1045 46.5837 48.5104 44.9896C46.9163 43.3955 44.7543 42.5 42.5 42.5C40.2457 42.5 38.0837 43.3955 36.4896 44.9896C34.8955 46.5837 34 48.7457 34 51C34 53.2543 34.8955 55.4164 36.4896 57.0104C38.0837 58.6045 40.2457 59.5 42.5 59.5C44.7543 59.5 46.9163 58.6045 48.5104 57.0104C50.1045 55.4164 51 53.2543 51 51Z",
    fill: "#828284"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_180_2599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7498 15.7518C51.41 14.0916 51.41 11.3955 49.7498 9.73535C48.0896 8.0752 45.3936 8.0752 43.7334 9.73535L1.2334 52.2354C-0.426758 53.8955 -0.426758 56.5916 1.2334 58.2518C2.89355 59.9119 5.58965 59.9119 7.2498 58.2518L49.7498 15.7518Z",
    fill: "#BFBFBF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_2599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 68,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_180_2599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/percentage.27cdaff2cf48fe317c2586dc7c73df4f.svg";
export { ForwardRef as ReactComponent };